import React from 'react';
import { ZapIcon, RefreshCwIcon, LockIcon } from 'lucide-react';
export function DifferenceSection() {
  const differences = [{
    icon: ZapIcon,
    title: 'Truly Automatic',
    description: 'No scanning QR codes or Coupon Codes. Just pay with your UPI/ linked card and earn rewards instantly.',
    color: 'bg-[#A020F0]'
  }, {
    icon: RefreshCwIcon,
    title: 'Works Everywhere',
    description: 'One app for all your favorite local spots, not separate apps for each store.',
    color: 'bg-[#A020F0]'
  }, {
    icon: LockIcon,
    title: 'Privacy First',
    description: 'Your data is never sold. We only track visits to help you earn rewards.',
    color: 'bg-[#A020F0]'
  }];
  return <section className="py-16 bg-[#f0ebff]" data-id="element-83">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-84">
        <div className="text-center mb-12" data-id="element-85">
          <h2 className="text-3xl sm:text-4xl font-bold mb-4" data-id="element-86">
            What Makes Kraya Different
          </h2>
          <div className="h-1 w-20 bg-[#FFDE59] mx-auto" data-id="element-87"></div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-88">
          {differences.map((item, index) => <div key={index} className="bg-white rounded-2xl p-8 shadow-sm hover:shadow-md transition-shadow duration-200 text-center transform hover:-translate-y-1 hover:border-[#A020F0] border-2 border-transparent" data-id="element-89">
              <div className={`${item.color} w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-6`} data-id="element-90">
                <item.icon className="h-8 w-8 text-white" data-id="element-91" />
              </div>
              <h3 className="text-xl font-bold mb-3" data-id="element-92">{item.title}</h3>
              <p className="text-gray-600" data-id="element-93">{item.description}</p>
            </div>)}
        </div>
      </div>
    </section>;
}